export const KEY_CREATED_ON = "created";
export const KEY_OWNER = "owner_id";
export const KEY_CO_OWNER = "coowner_id";
export const KEY_LAST_MODIFIED = "activity";
export const KEY_MODULE = "module";
export const KEY_CONVERT = "Convert";
export const KEY_ACCOUNT = "account";
export const KEY_ACTIONS = "Actions";
export const KEY_CONTACT_NAME = "Contact Name";
